// saboteurAlgorithm.jsx — Scoring client-side para o Teste de Sabotadores

import { QUESTIONS } from "@/components/saboteur/saboteurData";
import { SABOTEUR_ORDER } from "@/components/saboteur/saboteurProfileData";

export function calculateSaboteurResult(answers) {
  // 1. Agrupar respostas por sabotador
  const groups = {};
  for (const q of QUESTIONS) {
    if (!groups[q.saboteur]) groups[q.saboteur] = [];
    if (answers[q.id] !== undefined) {
      groups[q.saboteur].push(answers[q.id]);
    }
  }

  // 2. Média Likert por sabotador (1-5)
  const averages = {};
  for (const key of SABOTEUR_ORDER) {
    const vals = groups[key] || [];
    averages[key] = vals.length > 0
      ? vals.reduce((sum, v) => sum + v, 0) / vals.length
      : 0;
  }

  // 3. Normalizar para 0-100: ((média - 1) / 4) * 100
  const scores = {};
  for (const key of SABOTEUR_ORDER) {
    scores[key] = Math.round(((averages[key] - 1) / 4) * 100);
  }

  // 4. Ordenar desc → ranking[]
  const ranking = [...SABOTEUR_ORDER].sort((a, b) => scores[b] - scores[a]);

  // 5. Top 3 = dominants[]
  const dominants = ranking.slice(0, 3);

  // 6. primarySaboteur = primeiro não-juiz do ranking (juiz é universal)
  const primarySaboteur = ranking.find(s => s !== "juiz") || ranking[0];

  // 7. Score do juiz separado (sempre relevante)
  const juizScore = scores.juiz;

  return {
    scores,
    averages,
    ranking,
    dominants,
    primarySaboteur,
    juizScore,
  };
}
